<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import Module9Item from '../content/Module9Item.vue'

import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp9',
  components: { ModuleTitle, Module9Item },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getShadowColor }
}
</script>

<template>
  <div class="modules-id-9">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-3 modules-id-9-content">
      <module9-item
        v-for="(v, i) in moduleOption.list.slice(0, 2)"
        :key="`module9-item-${i}`"
        :headline="v.memo"
        :name="v.name"
      />
      <!-- <div
        v-for="v in moduleOption.list.slice(0, 2)"
        :key="`modules-9-${v.id}`"
        class="item"
        :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
      >
        <div class="item-box">
          <p class="item-title">{{ v.headline }}</p>
          <p class="item-name">——— {{ v.name }}</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-9-content {
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  height: 100%;
}
</style>
